module.exports = __webpack_public_path__ + "static/media/exit.0feab36f.svg";